import React from 'react';
import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { IconButton } from '@bibliocommons/base-buttons';
import { Share, Print } from '@bibliocommons/base-icons';
import BackToLink from 'app/components/shared/BackToLink';

import './HeaderBar.scss';

export default function HeaderBar() {
  return (
    <div className="cp-header-bar">
      <BackToLink />
      <FeatureTogglz>
        {features =>
          features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? (
            <div className="print-share-buttons">
              <IconButton className="print-button" dataKey="print-button">
                <Print />
              </IconButton>
              <IconButton className="share-button" dataKey="share-button">
                <Share />
              </IconButton>
            </div>
          ) : null}
      </FeatureTogglz>
    </div>
  );
}
